import styled from 'styled-components';
import { Actions } from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItemActions/AuctionItemActions.style';
import { TextButton } from '@riac/design-system';
import { LazyImg } from '@riac/design-system';

export const Description = styled.div`
  margin: 0 15px;
`;

export interface ICompactComponent {
  compact: boolean;
}

export const LotImageObject = styled.object`
  &,&>img {
    width: 100%;
  }
`;

export const LotImage = styled.div`
  position: relative;
  display: inline-block;
`;

export const MultiItemOverlay = styled.div<ICompactComponent>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  overflow: hidden;
  p {
    color: #fff;
    display: inline-block;
    margin: 0.5rem;
    font-size: 16px;
    @media (max-width: 1560px) and (min-width: 1351px) {
      font-size: 12px;
    }
    @media (max-width: 1350px) and (min-width: 767px) {
      font-size: 12px;
      span:first-child {
        display: none;
      }
    }
    ${(props) => props.compact
    ? `span:first-child {
      display: none;
    }` : ''}
  }
`;

export const NRAFFF = styled(LazyImg)`
  position: absolute;
  top: -6px;
  right: -8px;
  width: 40%;
  min-width: 70px;
  max-width: 90px;
`;

export const LotTitle = styled.p`
  color: ${(props) => props.theme.black[100]};
`;

export const LotDetail = styled.p`
  font-size: 1.6rem;
  color: ${(props) => props.theme.black[70]};
  ${TextButton} {
    font-size: 1.8rem;
    margin-left: 5px;
    color: ${(props) => props.theme.black[70]};
    @media print {
      display: none;
    }
  }
`;

export const LotProperty = styled.span`
  flex-shrink: 0;
  font-size: 1.6rem;
  color: ${(props) => props.theme.black[100]};
`;

export const Item = styled.li<ICompactComponent>`
  list-style: none;
  padding: 15px 0px;
  border-bottom: 1px solid ${(props) => props.theme.black[30]};
  display: flex;
  flex-wrap: wrap;
  @media print {
    break-inside: avoid;
    flex-wrap: nowrap;
    * {
      font-size: 0.8rem;
    }
  }
  ${(props) => props.theme.tablet} {
    flex-wrap: nowrap;
  }
  ${LotImage} {
    flex-shrink: 1;
    ${(props) => props.theme.tablet} {
      flex-basis: 20%;
      flex-shrink: 0;
    }
    ${(props) => props.theme.desktop} {
      flex-basis: ${(props) => (props.compact ? '10%' : '15%')};
    }
    @media print {
      flex-basis: 10%;
    }
  }
  ${Description} {
    flex-grow: 1;
  }
  ${Actions} {
    flex-basis: 100%;
    ${(props) => props.theme.tablet} {
      flex-basis: ${(props) => (props.compact ? '35%' : '25%')};
      flex-shrink: 0;
    }
    @media print {
      display: none;
    }
  }
`;
